








































































































import { Component, mixins } from 'nuxt-property-decorator'
import MixinProductCard from '~/assets/mixins/product-card'
import ComponentProductMoreDetailsLink from '~/components/products/product-more-details-link.vue'
import ComponentProductBuyButton from '~/components/products/product-buy-button.vue'
import ComponentProductDetailPricesLight from '~/components/products/product-detail-prices-light.vue'
import ComponentRating from '~/components/rating/rating.vue'
import ComponentCatalogLabels from '~/components/catalog/labels/labels.vue'
import ComponentProductAspects from '~/components/products/product-aspects.vue'
import ComponentProductFeature from '~/components/products/product-feature.vue'
import ComponentProductCardImage from '~/components/products/card/product-card-image.vue'
import ComponentProductFavouriteButton from '~/components/products/card/product-favourite-button.vue'
import ComponentProductBonus from '~/components/products/card/product-bonus.vue'

// Список каталога на мобильной: фото и рейтинг слева, остальное справа.
// Фото — по своей высоте, без распорки по ratio (imageStyle не передаём).
@Component({
  components: {
    ComponentProductMoreDetailsLink,
    ComponentProductBuyButton,
    ComponentProductDetailPricesLight,
    ComponentRating,
    ComponentCatalogLabels,
    ComponentProductAspects,
    ComponentProductFeature,
    ComponentProductCardImage,
    ComponentProductFavouriteButton,
    ComponentProductBonus,
  },
})
export default class ComponentMobileProductItem3 extends mixins(
  MixinProductCard
) {}
